<template>
    <a-drawer :title="title" width="1200" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-row :gutter="10">
                <a-col :span="6">
                    <a-form-model-item label="期次名称" prop="name">
                        <a-input v-model="field.name" placeholder="请填写期次名称" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="期次编号" prop="type">
                        <a-input v-model="field.sno" placeholder="请填写期次编号" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="课程信息" prop="cid">
                        <a-select v-model="field.cid" show-search :filter-option="false" @search="doQueryCourse" placeholder="请选择课程">
                            <template v-for="course in courses">
                                <a-select-option :value="course.id" :key="course.id">{{ course.name }}</a-select-option>
                            </template>
                        </a-select>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="本期讲师" prop="ctaid">
                        <a-select v-model="field.ctaid" show-search :filter-option="false" @search="doQueryCta" placeholder="请选择本期讲师">
                            <template v-for="cta in ctas">
                                <a-select-option :value="cta.id" :key="cta.id">
                                    {{ cta.name }}
                                </a-select-option>
                            </template>
                        </a-select>
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="10">
                <a-col :span="6">
                    <a-form-model-item label="开始日期" prop="start">
                        <a-date-picker v-model="field.start" placeholder="请选择课程开始日期" value-format="YYYY-MM-DD" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="结束日期" prop="end">
                        <a-date-picker v-model="field.end" placeholder="请选择课程结束日期" value-format="YYYY-MM-DD" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="截至日期" prop="closing">
                        <a-date-picker v-model="field.closing" placeholder="请选择报名截至日期" value-format="YYYY-MM-DD" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="3">
                    <a-form-model-item label="优惠金额" prop="dis">
                        <a-input-number v-model="field.dis" :min="0" :max="1000000" :step="1.0" :precision="2" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="3">
                    <a-form-model-item label="奖学金" prop="award">
                        <a-input-number v-model="field.award" :min="0" :max="1000000" :step="1.0" :precision="2" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="10">
                <a-col :span="12">
                    <a-form-model-item label="组织单位" prop="orgunit">
                        <a-input v-model="field.orgunit" placeholder="请填写组织单位" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="12">
                    <a-form-model-item label="开班地点" prop="addr">
                        <a-input v-model="field.addr" placeholder="请填写开班地点" />
                    </a-form-model-item>
                </a-col>
            </a-row>
            <a-row :gutter="10">
                <a-col :span="6">
                    <a-form-model-item label="联系人" prop="linker">
                        <a-input v-model="field.linker" placeholder="请填写联系人" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="联系方式" prop="linktel">
                        <a-input v-model="field.linktel" placeholder="请填写联系方式" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6">
                    <a-form-model-item label="佣金计算方式" prop="brot">
                        <a-radio-group v-model="field.brot" button-style="solid">
                            <a-radio-button value="Amt">
                                固定金额
                            </a-radio-button>
                            <a-radio-button value="Rate">
                                比例金额
                            </a-radio-button>
                        </a-radio-group>
                    </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="field.brot === 'Amt'">
                    <a-form-model-item label="佣金金额" prop="broa">
                        <a-input-number v-model="field.broa" :min="0" :max="1000000" :step="1.0" :precision="2" />
                    </a-form-model-item>
                </a-col>
                <a-col :span="6" v-if="field.brot === 'Rate'">
                    <a-form-model-item label="佣金比例" prop="bror">
                        <a-input-number v-model="field.bror" :min="0" :max="1" :step="0.01" :precision="2" />
                    </a-form-model-item>
                </a-col>
            </a-row>

            <a-form-model-item label="备注说明" prop="memo">
                <a-textarea v-model="field.memo" placeholder="请填写备注说明" :auto-size="{ minRows: 3, maxRows: 3 }" />
            </a-form-model-item>
            <a-form-model-item label="海报图模板" prop="poster">
                <codemirror v-model="field.poster" :options="{ tabSize: 2, mode: 'text/html', lineNumbers: true, lineWrapping: true }"></codemirror>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<style>
.CodeMirror {
    border: 1px solid #eee;
    height: auto;
    min-height: 300px;
    max-height: 300px;
}

.CodeMirror-scroll {
    height: auto;
    min-height: 300px;
    max-height: 300px;
    overflow-y: hidden;
    overflow-x: auto;
}
</style>

<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/xml/xml.js'

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    components: {
        codemirror
    },
    data() {
        return {
            detail: {},
            init: false,
            field: {
                id: '',
                ctaid: '',
                cid: '',
                sno: '',
                name: '',
                start: '',
                end: '',
                closing: '',
                dis: '0.00',
                award: '0.00',
                orgunit: '',
                addr: '',
                memo: '',
                linker: '',
                linktel: '',
                poster: '',
                brot: 'Amt',
                broa: '0.00',
                bror: '0.00'
            },
            rules: {
                ctaid: [{ required: true, message: '请选择讲师', trigger: 'change' }],
                cid: [{ required: true, message: '请选择课程', trigger: 'change' }],
                sno: [{ required: true, message: '请填写期次编号', trigger: 'blur' }],
                name: [{ required: true, message: '请填写期次名称', trigger: 'blur' }],
                start: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
                end: [{ required: true, message: '请选择结束日期', trigger: 'change' }],
                closing: [{ required: true, message: '请选择截至日期', trigger: 'change' }],
                dis: [{ required: true, message: '请填写优惠金额', trigger: 'blur' }],
                award: [{ required: true, message: '请填写奖励金额', trigger: 'blur' }],
                orgunit: [{ required: true, message: '请填写组织单位', trigger: 'blur' }],
                addr: [{ required: true, message: '请填写开班地点', trigger: 'blur' }],
                linker: [{ required: true, message: '请填写联系人', trigger: 'blur' }],
                linktel: [{ required: true, message: '请填写联系方式', trigger: 'blur' }],
                brot: [{ required: true, message: '请选择佣金计算方式', trigger: 'blur' }],
                broa: [{ required: true, message: '请填写佣金金额', trigger: 'blur' }],
                bror: [{ required: true, message: '请填写佣金比例', trigger: 'blur' }]
            },
            courses: [],
            ctas: [],
            fetching: false
        }
    },
    mounted() {
        if (this.item.id) {
            this.$http
                .get('/crs/train/classes/detail', {
                    params: {
                        id: this.item.id
                    }
                })
                .then(result => {
                    this.detail = result.data
                    Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))
                    this.field.cid = this.detail.course.id
                    this.field.ctaid = this.detail.cta.id
                    this.courses.push(this.detail.course)
                    this.ctas.push(this.detail.cta)
                    this.init = true
                    this.initData()
                })
        } else {
            this.init = true
            this.initData()
        }
    },
    methods: {
        initData() {
            this.doQueryCourse('')
            this.doQueryCta('')
        },
        doQueryCourse(key) {
            this.fetching = true
            this.$http
                .get('/sys/data/crs/train/course', {
                    params: {
                        size: 25,
                        name: key
                    },
                    loading: {
                        flag: false
                    }
                })
                .then(result => {
                    if (this.detail.id) {
                        this.courses = [this.detail.course].concat(result.datas.filter(e => e.id != this.detail.course.id))
                    } else {
                        this.courses = result.datas
                    }

                    this.fetching = false
                })
        },
        doQueryCta(key) {
            this.fetching = true
            this.$http
                .get('/sys/data/user/cta', {
                    params: {
                        size: 25,
                        name: key,
                        sign: true
                    },
                    loading: {
                        flag: false
                    }
                })
                .then(result => {
                    if (this.detail.id) {
                        this.ctas = [this.detail.cta].concat(result.datas.filter(e => e.id != this.detail.cta.id))
                    } else {
                        this.ctas = result.datas
                    }
                    this.fetching = false
                })
        },
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/crs/train/classes/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))
                this.field.cid = this.detail.courses.id
                this.field.ctaid = this.detail.cta.id
            }
        }
    }
}
</script>
